import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { PagesComponent } from './pages/pages.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { LockScreenComponent } from './pages/lock-screen/lock-screen.component';

// { path: '', loadChildren: () => import('./pages/1.tv/app-search-site/app-search-site.module').then(m => m.AppSearchSiteModule) },
const routes: Routes = [
  // { path: '', pathMatch: 'prefix', redirectTo: 'search-sites' },
  {
    path: '',
    component: PagesComponent, children: [
      // { path: '', redirectTo: '/landing', pathMatch: 'full' },
      { path: '', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule) },
      { path: 'about', loadChildren: () => import('./pages/about/about.module').then(m => m.AboutModule) },
      { path: 'contact', loadChildren: () => import('./pages/contact/contact.module').then(m => m.ContactModule) },
      { path: 'menu', loadChildren: () => import('./pages/menu/menu.module').then(m => m.MenuModule) },
      { path: 'requests', loadChildren: () => import('./pages/requests/requests.module').then(m => m.RequestsModule) },
      { path: 'chefs', loadChildren: () => import('./pages/chefs/chefs.module').then(m => m.ChefsModule) },
      { path: 'reservation', loadChildren: () => import('./pages/reservation/reservation.module').then(m => m.ReservationModule) },
      { path: 'account', loadChildren: () => import('./pages/account/account.module').then(m => m.AccountModule) },
      { path: 'cart', loadChildren: () => import('./pages/cart/cart.module').then(m => m.CartModule) },
      { path: 'checkout', loadChildren: () => import('./pages/checkout/checkout.module').then(m => m.CheckoutModule) },
      { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule) },
      { path: 'logout', loadChildren: () => import('./pages/logout/logout.module').then(m => m.LogoutModule) },
      { path: 'register', loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterModule) },
      { path: 'faq', loadChildren: () => import('./pages/faq/faq.module').then(m => m.FaqModule) },
      { path: 'terms-conditions', loadChildren: () => import('./pages/terms-conditions/terms-conditions.module').then(m => m.TermsConditionsModule) },
      { path: 'digital-signage', loadChildren: () => import('./pages/1.tv/digital-signage/digital-signage.module').then(m => m.DigitalSignageModule) },
      { path: 'table-service', loadChildren: () => import('./pages/1.tv/table-service/table-service.module').then(m => m.TableServiceModule) },
      { path: 'home-delivery', loadChildren: () => import('./pages/1.tv/home-delivery/home-delivery.module').then(m => m.HomeDeliveryModule) },
      { path: 'restrooms', loadChildren: () => import('./pages/1.tv/restrooms/restrooms.module').then(m => m.RestroomsModule) },
      { path: 'tracking', loadChildren: () => import('./pages/1.tv/tracking/tracking.module').then(m => m.TrackingModule) },
      { path: 'auction', loadChildren: () => import('./pages/1.tv/auction/auction.module').then(m => m.AuctionModule) },
      { path: 'apps', loadChildren: () => import('./pages/1.tv/apps/apps.module').then(m => m.AppsModule) },
    ]
  },
  { path: 'landing', loadChildren: () => import('./pages/landing/landing.module').then(m => m.LandingModule) },
  { path: 'search-sites', loadChildren: () => import('./pages/1.tv/app-search-site/app-search-site.module').then(m => m.AppSearchSiteModule) },
  { path: 'search-companies', loadChildren: () => import('./pages/1.tv//app-search-company/app-search-company.module').then(m => m.AppSearchCompanyModule) },
  // { path: 'search-sites', component: AppSearchSiteViewComponent },
  { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },
  { path: 'appTableService', loadChildren: () => import('./a-apps/a-apps.module').then(m => m.AAppsModule) },
  { path: 'lock-screen', component: LockScreenComponent },
  { path: '**', component: NotFoundComponent },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // preloadingStrategy: PreloadAllModules, // <- comment this line for activate lazy load
      // initialNavigation: 'enabled', // for one load page, without reload
      relativeLinkResolution: 'legacy'
      // useHash: true
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
